import { BespokeFormModule } from '../bespoke-form/bespoke-form.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { ProductGroupDetailComponent } from './product-group-detail/product-group-detail.component';
import { ProductGroupPreviewComponent } from './product-group-preview/product-group-preview.component';
import { ProductRangePreviewComponent } from './product-range-preview/product-range-preview.component';
import { ProductRangeDetailComponent } from './product-range-detail/product-range-detail.component';
import { SpecialOffersComponent } from './special-offers/special-offers.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ProductDetailsSliderComponent } from './product-details/product-details-slider/product-details-slider.component';
import { ProductDetailsOrderComponent } from './product-details/product-details-order/product-details-order.component';
import { ProductDetailsImagesComponent } from './product-details/product-details-images/product-details-images.component';
import { ProductDetailsAttributesComponent } from './product-details/product-details-attributes/product-details-attributes.component';
import { ProductDetailsRatingComponent } from './product-details/product-details-rating/product-details-rating.component';
import { ProductDetailsDescriptionComponent } from './product-details/product-details-description/product-details-description.component';
import { ProductDetailsPatternSliderComponent } from './product-details-pattern-slider/product-details-pattern-slider.component';
import { ProductDetailsRelatedProductsComponent } from './product-details/product-details-related-products/product-details-related-products.component';
import { ProductDetailsRelatedProductsSliderComponent } from './product-details/product-details-related-products-slider/product-details-related-products-slider.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PriceBandModalComponent } from './product-details/price-band-modal/price-band-modal.component';
import { DirectivesModule } from '../../directives/directives.module';
import { ColourVariationsModalComponent } from './product-details/colour-variations-modal/colour-variations-modal.component';
import { ProductDetailsLayoutComponent } from '../../layouts/product-details-layout/product-details-layout.component';
import { DefaultLayoutComponent } from '../../layouts/default-layout/default-layout.component';
import { PageIntroModule } from '../../shared/page-intro/page-intro.component';
import { ChatModule } from '../chat/chat.module';
import { DefaultSiteSectionsModule } from '../default-site-sections/default-site-sections.module';
import { TrustpilotReviewSliderModule } from '../../shared/trustpilot-review-slider/trustpilot-review-slider.component';
import { ContactCtaModule } from '../../shared/contact-cta/contact-cta.component';
import { ProductStructuredDataComponent } from './product-structured-data/product-structured-data.component';
import { PipesModule } from '../../pipes/pipes.module';
import { PageNotFoundModule } from '../../cms/page-not-found/page-not-found.component';
import { CookieConsentModule } from '../cookie-consent/cookie-consent.module';
import { ProductGroupSliderComponent } from './product-details/product-group-slider/product-group-slider.component';
import { ProductStandAloneModule } from './product-stand-alone.module';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { MarketplaceFiltersComponent } from './marketplace/marketplace-filters/marketplace-filters.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

const routes: Routes = [
    {
        path: 'bespoke-builder',
        component: DefaultLayoutComponent,
        loadChildren: () => import('../bespoke/bespoke.module').then((m) => m.BespokeModule),
    },
    {
        path: 'bespoke',
        component: DefaultLayoutComponent,
        loadChildren: () => import('../bespoke-form/bespoke-form.module').then((m) => m.BespokeFormModule),
    },
    { path: 'marketplace', component: MarketplaceComponent, pathMatch: 'full' },
    { path: 'marketplace/:slug', component: ProductDetailsLayoutComponent, pathMatch: 'full' },
    { path: ':slug', component: ProductDetailsLayoutComponent, pathMatch: 'full' },
];

@NgModule({
    declarations: [
        ProductDetailsLayoutComponent,
        ProductSearchComponent,
        ProductDetailsComponent,
        ProductGroupDetailComponent,
        ProductGroupPreviewComponent,
        ProductRangePreviewComponent,
        ProductRangeDetailComponent,
        SpecialOffersComponent,
        ProductDetailsSliderComponent,
        ProductDetailsOrderComponent,
        ProductDetailsImagesComponent,
        ProductDetailsAttributesComponent,
        ProductDetailsRatingComponent,
        ProductDetailsDescriptionComponent,
        ProductDetailsPatternSliderComponent,
        ProductDetailsRelatedProductsComponent,
        ProductDetailsRelatedProductsSliderComponent,
        ProductGroupSliderComponent,
        PriceBandModalComponent,
        SpecialOffersComponent,
        ColourVariationsModalComponent,
        ProductStructuredDataComponent,
        MarketplaceComponent,
        MarketplaceFiltersComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        AngularSvgIconModule,
        NgSelectModule,
        DirectivesModule,
        [RouterModule.forChild(routes)],
        PageIntroModule,
        ChatModule,
        DefaultSiteSectionsModule,
        TrustpilotReviewSliderModule,
        ContactCtaModule,
        PipesModule,
        BespokeFormModule,
        PageNotFoundModule,
        CookieConsentModule,
        ProductStandAloneModule,
        NgxSliderModule,
    ],
    exports: [
        ProductSearchComponent,
        ProductDetailsComponent,
        ProductGroupDetailComponent,
        ProductGroupPreviewComponent,
        ProductRangePreviewComponent,
        PriceBandModalComponent,
        ColourVariationsModalComponent,
        [RouterModule],
    ],
})
export class ProductModule { }
